import React from 'react';
import * as S from './styled';
export const ProductVariantsTooltipContent = ({ variants }) => (React.createElement(S.Container, null,
    React.createElement(S.Header, null,
        React.createElement(S.Label, null, "Variant"),
        React.createElement(S.Label, null, "Stock")),
    React.createElement(S.Content, null, variants.map(({ id, attributesDescription, quantity }) => (React.createElement(S.Variant, { key: id },
        React.createElement(S.Name, null, attributesDescription),
        React.createElement(S.StockCount, null, quantity || 'Unlimited')))))));
